import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { cn } from "@/lib/utils";
import { ILessonByWeek } from "@/types/lesson.types";
import LessonButton from "./LessonButton";

type LessonAccordionProps = {
  tab?: boolean;
  lessonsByWeeks: ILessonByWeek[];
};

const LessonAccordion = ({ tab, lessonsByWeeks }: LessonAccordionProps) => {
  return (
    <Accordion
      type="multiple"
      className={cn(
        "flex h-fit max-h-[650px] w-full flex-col gap-3 overflow-y-scroll",
        !tab && "max-md:hidden",
      )}
    >
      {lessonsByWeeks?.map((week) => (
        <LessonAccordionItem key={week.week} week={week} />
      ))}
    </Accordion>
  );
};

type LessonAccordionItemProps = {
  week: ILessonByWeek;
};

const LessonAccordionItem = ({ week }: LessonAccordionItemProps) => {
  const { week: weekNumber, lessons } = week;
  return (
    <AccordionItem value={`item-${weekNumber}`} className="h-fit">
      <AccordionTrigger>Week {weekNumber}</AccordionTrigger>
      <AccordionContent>
        {lessons?.map((lesson) => (
          <LessonButton key={lesson.id} lesson={lesson} />
        ))}
      </AccordionContent>
    </AccordionItem>
  );
};

export default LessonAccordion;
